// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import '@modernizr';
import '@custom-modernizr';
import App from './App';
import router from './router';
import store from './store';

Vue.config.productionTip = false;
sync(store, router);

Vue.prototype.$eventHub = new Vue();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App },
});

const bg = [
  'background: linear-gradient(135deg, rgba(235, 235, 235, 1) 0%, rgba(245, 245, 245, 1) 100%);',
  'color: #BE9B19',
  'padding: 5px 20px',
  'line-height: 25px',
].join(';');
console.log('%c🍾 Coded by Andrea & Tommaso @ Adoratorio 🍾', bg);



// WEBPACK FOOTER //
// ./src/main.js